import React, { useState } from 'react';
import { FaAddressCard, FaUser, FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // For Icons
import { Container, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";


const MultiStepForm = () => {
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    { name: 'Company Info', icon: <FaAddressCard /> },
    { name: 'Contact Info', icon: <FaUser /> },
    { name: 'KYC Documents', icon: <FaFileAlt /> },
    { name: 'Declaration', icon: <FaCheckCircle /> },
  ];
  const navigate = useNavigate();


 
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

 
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    console.log("Form submitted!");
    navigate("/stakeholders");
  };

  return (
    <div id="msform" className="container mt-4 ">
    
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>


  {/* Company INFO  */}
     <Container className="mt-5" >
        <Form>
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 0 ? "block" : "none", 
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
              textAlign:"left"
            }}
           
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              Company Info
            </h6>
            <hr
              style={{
                margin:"5px",
                border: "1px solid #748292",
                width: "100%",
              }}
            />

           
            <div className="row mb-3" >
              <label className="col-md-3 col-form-label text-start ">Name of the Institution</label>
              <div className="col-md-9" >
                <input
                
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Company Legal Status
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Single Person Company (SPC)</option>
                  <option>With Limited Liability(WLL)</option>
                  <option>Partnership Company</option>
                  <option>Limited Partnership by Shares</option>
                  <option>Bahraini Shareholding Company(BSC)</option>
                  <option>Bahraini Shareholding Company(BSC Closed)</option>
                  <option>Foreign Company Branch (Company Representative)</option>   
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Country of Incorporation
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Afganistan</option>
                  <option>Albania</option>
                  </select>
              </div>
            </div>
 
                
            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start "> Company Registration Number</label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                />
              </div>
            </div>

        
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Date of Incorporation
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm" required />
              </div>
            </div>

          
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Registering Authority
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
              </div>
            </div>

            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Business Activity
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Annual Turnover (US$ Millions)
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Less than 50</option>
                  <option>51-99</option>
                  <option>100-250</option>
                  <option>251-500</option>
                  <option>501-1,000</option>
                  <option>Above 1,000</option>
                  </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Type of Profile
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Resident</option>
                  <option>Non-Resident</option>
                  </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Type of Account
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Individual</option>
                  <option>Entity</option>
                  </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Nature of Account
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Investment in Equities</option>
                  <option>Investment in Securities</option>
                  <option>Investment in Bonds</option>
                  <option>Investment in Commodities</option>
                  <option>Investment in Mutual Funds</option>
                  <option>Investment in Stocks</option>
                  <option>Investment in Digital Assets</option>
                  </select>
              </div>
            </div>
 
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Anticipated Volume
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>1 - 100,000 USD</option>
                  <option>100,000 - 500,000 USD</option>
                  <option>500,000 - 1,000,000 USD</option>
                  <option>1,000,000 - 10,000,000 USD </option>
                  <option>10,000,000 - 50,000,000 USD</option>
                  </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Source of Funds
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Salary</option>
                  <option>Business Activity</option>
                  <option>Savings</option>
                  <option>Pension </option>
                  <option>Inheritance</option>
                  <option>Gift</option>
                  <option>Bonus</option>
                  <option>Indemnity/End of Service Payment</option>
                  <option>Return of Investment</option>
                  <option>Other</option>
                  </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Purpose And Intended Nature Of The Business Relationship
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="NA"
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Regulatory Body or Listing Body If Applicable
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Names of Relevant Persons in Senior Management If Applicable
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Names of Relevant Persons in Senior Management If Applicable
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                />
              </div>
            </div>

            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
               No. of Employees
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Less than 10 Employees</option>
                  <option>11-25 Employees</option>
                  <option>26-50 Employees</option>
                  <option>51-99 Employees</option>
                  <option>100-500 Employees</option>
                  <option>Above 500 Employees</option>
                </select>
             </div>
            </div>  
          </fieldset>
          </Form>

            

       {/* contact info */}
        <fieldset
          style={{
           textAlign:"left",
           display: currentStep === 1 ? "block" : "none"}}>
           
          <div  style={{
            margin: "10px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px #748292",
            transition: "all 0.5s ease-in-out"}} >
              <h6 className="text-start " style={{ marginBottom: "0.7rem" }}>Contact Info</h6>
              <hr  style={{
                border: "1px solid #748292",
                margin: "5px",
                width: "100%",
              }}/>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
              Address(1)
              </label>
              <div className="col-md-9">
                <input
                  className="form-control shadow-sm"
                  placeholder="Enter the Address 1"
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
              Address(2)
              </label>
              <div className="col-md-9">
                <input
                  className="form-control shadow-sm"
                  placeholder="Enter the Address 2"
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">Location</label>
            </div>
              <div className="col-md-4">
                <input type="text" className="form-control shadow-sm" placeholder='City *' required/>
              </div>
              <div className="col-md-4">
                <input type="" className="form-control shadow-sm" placeholder='NA' required />
              </div>
             
              <div className="col-md-4">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>1</option>
                  <option>2</option>
                  </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Telephone *</label>
              <div className="col-md-9">
                <input
                  type="tel"
                  className="form-control shadow-sm"
                  placeholder="Enter your telephone number"
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Fax</label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your fax number (if any)"
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">E-Mail *</label>
              <div className="col-md-9">
                <input
                  type="email"
                  className="form-control shadow-sm"
                  placeholder="Enter your email address"
                  required
                />
                </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
                Website
              </label>
              <div className="col-md-9">
                <input
                  type="password"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
              </div>
            </div>
          </div>
        </fieldset>





          {/* KYC Documents */}
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 2 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
             
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              KYC Documents
              </h6>
              <hr
                style={{
                  border: "1px solid #748292",
                  margin: "5px",
                  width: "100%",
                }}
              />

              <p className="text-muted text-start mb-4">
                The file size must be under 10 MB and only PDF format is accepted.
              </p>

             
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Commercial Registration
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    required
                  />
                </div>
              </div>

             
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                VAT Registration Certificate
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    required
                  />
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Company Registration Extract
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Company Registration Extract
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Memorandum of Association
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Articles of Association
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Partnership Agreement
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Board Resolution
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                List of Authorized Signatories

                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Latest Financial Report and Accounts
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
            </div>
          </fieldset>

      {/* Declaration */}
       <fieldset
            style={{
              textAlign:"left",
              padding: "20px",
              display: currentStep === 3 ? "block" : "none", // Adjust for currentStep
            }}>
            <div
              style={{
                padding: "25px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
              >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Declarations
              </h6>
              <hr
                style={{
                  marginBottom: "0.5rem",
                  width:"100%",
                  border: "1px solid #748292"
                }}/>

          {/* Declaration Text */}
          <div className=" mb-3"
          >
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration1"
            checked={isChecked1}
            onChange={(e) => setIsChecked1(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration1">
          I/We hereby confirm that I/we are acting and would, in future will 
          also be acting on my/our behalf for the purpose of transactions, new
           accounts or providing any further information required by Blue Aster Capital BSC ©.
          </label>
        </div>

        <div className=" mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration2"
            checked={isChecked2}
            onChange={(e) => setIsChecked2(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration2">
          I/We hereby confirm the information provided above is true,
           accurate and complete. Subject to applicable local laws, I/we
            hereby consent for Blue Aster Capital BSC © or any of its affiliates to share our information with domestic or overseas regulators or tax authorities where necessary.
          </label>
        </div>

        <div className="mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration3"
            checked={isChecked3}
            onChange={(e) => setIsChecked3(e.target.checked)}
            required
          />
          <label className="form-check-label" htmlFor="declaration3">
          I/We agree and undertake to notify Blue Aster Capital BSC © within 30 calendar
           days if there is a change in any information which I/we have provided.
          </label>
        </div>


              {/* Name / Authorised Signatory Name */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Name / Authorised Signatory Name *
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    placeholder="Enter your name"
                    required
                  />
                </div>
              </div>

              {/* Digital Signature */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Digital Signature *
                </label>
                <div className="col-md-9">
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      height: "150px",
                      position: "relative",
                    }}>
                    <canvas
                      ref={(canvasRef) => {
                        if (canvasRef) {
                          const ctx = canvasRef.getContext("2d");
                          canvasRef.addEventListener("mousedown", (e) => {
                            ctx.isDrawing = true;
                            ctx.beginPath();
                            ctx.moveTo(e.offsetX, e.offsetY);
                          });

                          canvasRef.addEventListener("mousemove", (e) => {
                            if (ctx.isDrawing) {
                              ctx.lineTo(e.offsetX, e.offsetY);
                              ctx.stroke();
                            }
                          });

                          canvasRef.addEventListener("mouseup", () => {
                            ctx.isDrawing = false;
                          });

                          canvasRef.addEventListener("mouseleave", () => {
                            ctx.isDrawing = false;
                          });
                        }
                      }}
                      width="500"
                      height="150"
                      style={{ width: "100%", height: "100%" }}
                    ></canvas>
                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      style={{ position: "absolute", bottom: "-40px", right: "0" }}
                      onClick={() => {
                        const canvas = document.querySelector("canvas");
                        const ctx = canvas.getContext("2d");
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>


              {/* Date */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Date *
                </label>
                <div className="col-md-9">
                  <input
                    type="date"
                    className="form-control shadow-sm"
                    required
                  />
                </div>
              </div>
            </div>
          </fieldset>

      



      {/* Action buttons */}
      <div className="action-button-container" style={{textAlign:"center"}}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>

        
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit} 
          >
            Submit
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext}
            style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
          >
            Next
          </button>
        )}
      </div>
      </Container>

    </div>
  );
};

export default MultiStepForm;
